<template>
  <div>
    <div class="text-black text-2xl font-semibold mb-1">
      Tambah talent
    </div>
    <Bio />
  </div>
</template>

<script>
import Bio from './Bio.vue'

export default {
  components: { Bio },
}
</script>
